// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1507":"09adf392","7000":"09adf392"}[chunkId] + ".chunk.css";
};